import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from "@angular/router";
import { Observable } from "rxjs";

@Injectable()
export class AuthGuard implements CanActivate {

    constructor(private _router: Router) {
    }
    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | boolean {
        if (!!sessionStorage.getItem('currentUser_EPC_Portfolio') == true) {
            return true;
        } 
            this._router.navigate(['login'], { queryParams: { returnUrl: state.url } });
            return false;
        
    }
   
}